export default "__VITE_ASSET__BGoXztig__"